import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const CommunicationEventConfiguration = {
	name: NAME,
	apiProvider,
	router,
};
